import { render, staticRenderFns } from "./tradedetailjmc.vue?vue&type=template&id=3bfcb961&scoped=true&"
import script from "./tradedetailjmc.vue?vue&type=script&lang=js&"
export * from "./tradedetailjmc.vue?vue&type=script&lang=js&"
import style0 from "./tradedetailjmc.vue?vue&type=style&index=0&id=3bfcb961&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfcb961",
  null
  
)

export default component.exports